import axios from 'axios';
import { getStore, setStore } from './storage';
import router from '../router/index';
import { Message } from 'view-design';
import Cookies from 'js-cookie';
import appConfig from 'appConfig';
// 统一请求路径前缀
let base = appConfig.base;
let baseMapserver = appConfig.baseMapServer;
// 超时设定
axios.defaults.timeout = appConfig.timeout ? appConfig.timeout : 15000;




console.log(axios.defaults);

// axios.defaults.withCredentials = false
axios.interceptors.request.use(
  config => {
    return config;
  },
  err => {
    Message.warning('请求超时');
    return Promise.resolve(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    const data = response.data;
    // 根据返回的code值来做不同的处理(和后端约定)
    switch (data.code) {
      case 401:
        // 未登录 清除已登录状态
        Cookies.set('userInfo', '');
        Cookies.set('accessToken', '');
        setStore('accessToken', '');
        setStore('userInfo', '');
        router.push('/login');
        break;
      case 403:
        // 没有权限
        if (data.message !== null) {
          Message.info(data.message);
        } else {
          Message.warning('未知错误');
        }
        break;
      case 500:
        // 错误
        if (data.message !== null) {
          Message.info(data.message);
        } else {
          Message.warning('未知错误');
        }
        break;
      default:
        return data;
    }

    return data;
  },
  err => {
    // 返回状态码不为200时候的错误处理
    Message.warning(err.toString());
    return Promise.resolve(err);
  }
);
// 反馈提交
export const postaddFeedback = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      accessToken: accessToken,
    },
  });
};

export const postloginRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function (data) {
        let ret = '';
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        return ret;
      },
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
    },
  });
};

// // 订单
// export const getOrderLisRequest = (url, params) => {
//   //let accessToken = getStore("accessToken");
//   let accessToken = Cookies.get("accessToken")
//   return axios({
//     method: 'get',
//     url: `${base}${url}`,
//     params: params,
//     headers: {
//       'Content-Type': 'application/json',
//       'accessToken': accessToken
//     }
//   });
// };
export const ssoRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'get',
    url: `sso/${url}`,
    params: params,
    headers: {
      accessToken: accessToken,
    },
  });
};

export const getRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params,
    headers: {
      // 'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};

// 商品详情
export const getDetails1 = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    params: params,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

// 订单
// export const getRequest = (url, params) => {
//
//   let accessToken = Cookies.get("accessToken")
//   return axios({
//     method: 'get',
//     url: `${base}${url}`,
//     params: params,
//     headers: {
//       'accessToken': accessToken
//     }
//   });
// };

export const getRequest3 = (url, params) => {
  let accessToken = getStore('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};

export const getRequest4 = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
    },
  });
};

export const getRequest2 = url => {
  let accessToken = getStore('accessToken');

  var url = `${base}${url}`;
  //var $a = $("<a></a>").attr("href",url).attr("target","_Blank"); // 新窗口打开
  var $a = $('<a></a>')
    .attr('href', url)
    .attr('download', '属性模板.xlsx'); //下载
  $a[0].click();
};
export const postDataRequestex = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${baseMapserver}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};
//导出文件专用
export const postDataRequest2 = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${baseMapserver}${url}`,
    data: params,
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};
//导出文件专用
export const postDataRequestBase = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};
// 文件下载
export const postRequestpdfORimg = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    responseType: 'blob',
    transformRequest: [
      function (data) {
        let ret = '';
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        return ret;
      },
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
    },
  });
};
// get下载
export const getRequestpdfORimg = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params,
    responseType: 'blob',
    transformRequest: [
      function (data) {
        let ret = '';
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        return ret;
      },
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
    },
  });
};
//导出文件专用
export const postDataRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${baseMapserver}${url}`,
    data: params,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};

export const getDataRequest = (url, { params, option }) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
    ...option,
  });
};

export const postRequest = (url, params) => {
  //let accessToken = getStore("accessToken");
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function (data) {
        let ret = '';
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        return ret;
      },
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
    },
  });
};
export const postRequest1 = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      accessToken: accessToken,
    },
  });
};
export const showmideaRequest22 = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
    },
  });
};
export const formDatapostRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data',
      accessToken: accessToken,
    },
  });
};

export const putRequest = (url, params) => {
  //let accessToken = getStore("accessToken");
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function (data) {
        let ret = '';
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        return ret;
      },
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
    },
  });
};

export const deleteRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'delete',
    url: `${base}${url}`,
    params: params,
    headers: {
      accessToken: accessToken,
    },
  });
};
export const deletePRequest = url => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'get',
    url: `${base}${url}`,
    //params: params,
    headers: {
      accessToken: accessToken,
    },
  });
};
export const showDataRequest = url => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'get',
    url: `${base}${url}`,
    //params: params,
    headers: {
      accessToken: accessToken,
    },
  });
};
export const showmideaRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  let users = localStorage.getItem('userInfo');
  users = JSON.parse(users);
  params.username = users.username;
  url =
    url +
    '?type=' +
    params.type +
    '&geometryID=' +
    params.geometryID +
    '&username=' +
    params.username;
  return axios({
    method: 'get',
    url: `${url}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
    },
  });
};
export const deleteMideaRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');

  //url = url+"?type="+ params.type+"&storagefilePath="+params.storagefilePath;

  return axios({
    method: 'post',
    url: `${url}`,
    data: {
      type: params.type,
      storagefilePath: params.storagefilePath,
    },
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });

  //return axios({
  //  method: 'get',
  //  url: `${url}`,
  //  headers: {
  //    'Content-Type': 'application/x-www-form-urlencoded',
  //    'accessToken': accessToken
  //  }
  //});
};
export const getusrdataRequest = url => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'get',
    url: `${base}${url}`,
    //params: params,
    headers: {
      accessToken: accessToken,
    },
  });
};
// getOrderListurl
export const saveDataRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};

export const saveusrDataRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};

export const uploadFileRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    params: params,
    headers: {
      accessToken: accessToken,
    },
  });
};
export const importRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      accessToken: accessToken,
    },
  });
};

export const postRequest2 = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};



// WEBPACK FOOTER //
// ./src/utils/axios.js